import React from 'react'

export default function OutletRequest() {
    return (
        <div></div>
    )
}
